module.exports = __webpack_public_path__ + "static/media/Ref_Letter2.49796511.jpg";